import IframeActivity from "./IframeActivity";

export default function DividedAttention() {
    return (
        <IframeActivity
            src="/activities/divided-attention/index.html"
            title="Divided Attention"
        />
    );
}